<script>
  import Badge from '@leaflink/stash/Badge.vue';
  import Icon from '@leaflink/stash/Icon.vue';
  import { storeToRefs } from 'pinia';
  import { useRouter } from 'vue-router';
  import { mapActions, mapGetters, mapState } from 'vuex';

  import { useUserStore } from '@/piniaStores/user/user.store';
  import { track } from '@/track';

  export default {
    name: 'miniCartToggle',

    components: {
      Badge,
      Icon,
    },

    props: {
      disabled: {
        type: Boolean,
        default: false,
      },
      isActive: {
        type: Boolean,
        default: false,
      },
      show: {
        type: Function,
        default: () => {},
      },
    },
    data() {
      return {
        cartUpdated: false,
      };
    },

    setup() {
      const router = useRouter();
      const userStore = useUserStore();
      const { getIsSplitEnabled } = storeToRefs(userStore);

      return {
        router,
        getIsSplitEnabled,
      };
    },

    computed: {
      ...mapGetters('cart', ['companiesInCart', 'uniqueProducts', 'subtotal', 'items', 'itemCount']),
      ...mapState('cart', ['cartCountOverride', 'isLoading', 'isLoaded']),
      cartCount() {
        return this.cartCountOverride || this.itemCount;
      },
    },
    watch: {
      cartCountOverride() {
        if (!this.cartCountOverride) {
          return;
        }

        // Set cart updated to true to trigger the cart icon animation
        this.cartUpdated = true;
        // After the animation is complete reset the cartUpdated flag
        setTimeout(() => {
          this.cartUpdated = false;
        }, 1200);
      },
    },
    methods: {
      ...mapActions('cart', ['fetchCart']),
      /**
       * Loads and opens the mini-cart
       */
      openMiniCart: function () {
        const inCart = !!window.location.href.match(/cart?\/$/);

        if (this.itemCount && !inCart) {
          const cartPromise = this.isLoaded ? Promise.resolve() : this.fetchCart();

          if (!this.isActive) {
            cartPromise.then(() => {
              track('Minicart Viewed', {
                product_count: this.items.length,
                unique_product_count: this.uniqueProducts.length,
                subtotal: this.subtotal,
                buying_accounts: this.companiesInCart,
              });
            });
          }

          this.show();
        } else {
          if (this.getIsSplitEnabled('ssr_iframe')) {
            this.router.push('/cart');
          } else {
            window.location.href = '/cart';
          }
        }
      },
    },
  };
</script>

<template>
  <Badge
    data-test="button|mini-cart-toggle"
    class="tw-cursor-pointer"
    :content="cartCount"
    animate
    @click="openMiniCart()"
  >
    <Icon name="shop-cart" />
  </Badge>
</template>
